<script lang="ts">
  import ListingLi from '#listings/components/listing_li.svelte'
  import type { SerializedListingWithElements } from '#listings/lib/listings'
  import { i18n } from '#user/lib/i18n'

  const {
    listings,
  }: {
    listings: SerializedListingWithElements[]
  } = $props()
</script>

<ul class="listings-layout">
  {#each listings as listing (listing._id)}
    <ListingLi {listing} />
  {/each}
  {#if listings.length === 0}
    <li class="empty">
      {i18n('There is nothing here')}
    </li>
  {/if}
</ul>

<style lang="scss">
  @import "general/scss/utils";
  .listings-layout{
    @include display-flex(row, center, center, wrap);
    margin: auto;
    overflow-y: auto;
  }
  .empty{
    color: $grey;
    text-align: center;
  }
</style>
